// Environment configuration using .env files
// The following variables are available from .env files:
// - VUE_APP_BASE_URL: The base URL of the frontend application
// - VUE_APP_API_BASE_URL: The base URL for API calls

// Get environment variables (with fallbacks)
const ENV_BASE_URL = process.env.VUE_APP_BASE_URL || 'http://localhost:8080';
let API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api';

// Force API URL to be relative in production to avoid domain issues
if (process.env.NODE_ENV === 'production') {
  API_BASE_URL = '/api';
}

// Log environment configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('Environment Configuration:', {
    BASE_URL: ENV_BASE_URL,
    API_URL: API_BASE_URL,
    NODE_ENV: process.env.NODE_ENV
  });
}

// Always log in production for debugging
// console.log('Environment Configuration:', {
//   BASE_URL: ENV_BASE_URL,
//   API_URL: API_BASE_URL,
//   NODE_ENV: process.env.NODE_ENV,
//   VUE_APP_API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
//   VUE_APP_BASE_URL: process.env.VUE_APP_BASE_URL
// });

// Environment configuration
const config = {
  // Development environment
  development: {
    baseUrl: ENV_BASE_URL,
    apiUrl: API_BASE_URL
  },
  
  // Production environment
  production: {
    baseUrl: ENV_BASE_URL,
    apiUrl: API_BASE_URL
  },
  
  // Test environment
  test: {
    baseUrl: ENV_BASE_URL,
    apiUrl: API_BASE_URL
  }
};

// Get current environment
const env = process.env.NODE_ENV || 'development';

// Export configuration for current environment
export const environment = config[env] || config.development;

// Export individual variables for convenience
export const API_URL = environment.apiUrl;
export const BASE_URL = environment.baseUrl; 